import { userActionTypes } from './user.types';
import http, { resetSessionExpiredFlag } from '../../services/http';
import { push } from 'connected-react-router';
import { getServiceGroups, getTextConfig, getTimeConfig } from '../serviceGroup/serviceGroup.actions';
import { getProfiles } from '../profile/profile.actions';
import { setLoading, setNotLoading } from '../loading/loading.actions';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { resetAppBootstrapGate } from '../../utils/appBootstrapGate';

export const selectCurrentUser = state => state.user.currentUser;
export const selectWelcomeMsg = state => state.user.welcomeMsg;
export const selectClosingMsg = state => state.user.closingMsg;
export const selectUsers = state => state.user.users;
export const selectIndicatorUsers = state => state.user.indicatorUsers;
export const selectPermissions = state => state.user.permissions;
export const selectAuthError = state => state.user.authError;
export const selectUpdateSuccess = state => state.user.updateSuccess;
export const selectToken = state => state.user.token;
export const selectUserStatus = state => state.user.userStatus;
export const selectShowSessionExpiredModal = state => state.user.showSessionExpiredModal;

export const setUsers = users => {
    return {
        type: userActionTypes.SET_USERS,
        payload: users
    };
};

export const setIndicatorUsers = indicatorUser => {
    return {
        type: userActionTypes.SET_INDICATOR_USERS,
        payload: indicatorUser
    }
};

export const setWelcomeMsg = welcomeMsg => {
    localStorage.setItem('welcomeMsg', welcomeMsg);
    return {
        type: userActionTypes.SET_WELCOME_MSG,
        payload: welcomeMsg
    }
};

export const setClosingMsg = closingMsg => {
    localStorage.setItem('closingMsg', closingMsg);
    return {
        type: userActionTypes.SET_CLOSING_MSG,
        payload: closingMsg
    }
};

const setToken = token => {
    return {
        type: userActionTypes.SET_TOKEN,
        payload: token
    }
};

export const setUserStatus = status => {
    return {
        type: userActionTypes.SET_USER_STATUS,
        payload: status
    }
};

export const setTransferUser = user => {
    return {
        type: userActionTypes.SET_TRANSFER_USER,
        payload: user
    }
}

export const getUsers = (options = {}) => {
    return async dispatch => {
        try {
            const params = {};
            if (options.includeInactive) {
                params.include_inactive = 1;
            }
            const response = await http.get(`/users`, { params });
            // Guarda o recorte junto da lista. É o que permite aos thunks que
            // recarregam sozinhos (status, editar, criar) repetirem o MESMO
            // recorte em vez de impor o deles.
            dispatch(setUsers({ users: response.data, query: { includeInactive: !!options.includeInactive } }));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        }
    };
};


export const getUser = (id) => {
    return async (dispatch, getState) => {
        try {
            const response = await http.get(`/users/${id}`)

            if (response && response.data) {
                dispatch(setCurrentUser(response.data));
                // Sempre atualiza permissões com o retorno da API (ex.: após alterar permissões do perfil)
                dispatch(setPermissions(response.data.permissions));
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                }
                localStorage.setItem('user', JSON.stringify(response.data.user));
                dispatch(getTextConfig(response.data.user.service_group_id));
                dispatch(getTimeConfig(response.data.user.service_group_id));
            }
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        };
    };
};

export const getTransferUser = (userId) => {
    return async (dispatch) => {
        try {
            const response = await http.get(`/users/${userId}`);
            dispatch(setTransferUser(response.data));
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar dados do usuário transferido:", error);
        }
    }
};

export const getUserIndicators = () => {
    return async dispatch => {
        try {
            const response = await http.get(`indicators/users`);
            dispatch(setIndicatorUsers(response.data)); // Em caso de sucesso
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        }
    };
};


export const setPermissions = (permissions) => {
    // Converte permissões para array se for objeto
    let permissionsArray = permissions;
    
    if (typeof permissions === 'string') {
        try {
            permissionsArray = JSON.parse(permissions);
        } catch (error) {
            console.error('Erro ao fazer parse das permissões:', error);
            permissionsArray = [];
        }
    }
    
    // Se for objeto, converte para array
    if (typeof permissionsArray === 'object' && !Array.isArray(permissionsArray)) {
        permissionsArray = Object.values(permissionsArray);
    }
    
    // Garantir que seja sempre um array
    if (!Array.isArray(permissionsArray)) {
        permissionsArray = [];
    }
    
    return {
        type: userActionTypes.SET_PERMISSIONS,
        payload: permissionsArray
    };
};

export const setCurrentUser = (data) => {
    return {
        type: userActionTypes.SET_CURRENT_USER,
        payload: data.user
    }
};

export const updateProfile = (profile) => {
    return async dispatch => {
        try {
            await http.put(`/profiles/${profile.id}`, profile);
            dispatch(getUsers());
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                console.log(error);
            }
        }
    };
};


export const setAuthError = (error) => ({
    type: userActionTypes.SET_AUTH_ERROR,
    payload: error
});

export const setUpdateSuccess = (success) => ({
    type: userActionTypes.SET_UPDATE_SUCCESS,
    payload: success
});

export const updateUserPresence = (userId, status) => {
    return async (dispatch, getState) => {
        dispatch(setLoading());
        try {
            const response = await http.put(`/users/${userId}/presence`, { status });
            const updatedUser = response.data.user;
            const state = getState();
            if (state.user.currentUser && Number(state.user.currentUser.id) === Number(updatedUser.id)) {
                dispatch({
                    type: userActionTypes.SET_CURRENT_USER,
                    payload: updatedUser
                });
                localStorage.setItem('user', JSON.stringify(updatedUser));
                dispatch(setUserStatus({ userId: updatedUser.id, status: updatedUser.status }));
            }
            dispatch(getUsers(getState().user.usersQuery));
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.data?.error === 'Token Error')) {
                dispatch(logOut());
            } else {
                console.error(error);
            }
        } finally {
            dispatch(setNotLoading());
        }
    };
};

// Status de CHAT do operador (item 11): 0 Indisponível / 1 Disponível. O
// próprio operador pode mudar o seu; o de outro exige permissão (backend valida).
export const updateChatStatus = (userId, chatStatus) => {
    return async (dispatch, getState) => {
        try {
            const response = await http.put(`/users/${userId}/chat-status`, { chat_status: chatStatus });
            const updatedUser = response.data.user;
            const state = getState();
            if (state.user.currentUser && Number(state.user.currentUser.id) === Number(updatedUser.id)) {
                dispatch({
                    type: userActionTypes.SET_CURRENT_USER,
                    payload: updatedUser,
                });
                localStorage.setItem('user', JSON.stringify(updatedUser));
            }
            return updatedUser;
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.data?.error === 'Token Error')) {
                dispatch(logOut());
            } else {
                const msg = error.response?.data?.message || 'Não foi possível alterar o status de chat.';
                toast.error(msg);
            }
            throw error;
        }
    };
};

export const updateUser = (user) => {
    return async (dispatch, getState) => {
        dispatch(setLoading());
        try {
            const response = await http.put(`/users/${user.id}`, user);
            const updatedUser = response.data.user;
            const state = getState();

            if (state.user.currentUser.id === updatedUser.id) {
                dispatch({
                    type: userActionTypes.SET_CURRENT_USER,
                    payload: updatedUser
                });

                if (updatedUser.token) {
                    localStorage.setItem('token', updatedUser.token);
                    dispatch(setToken(updatedUser.token));
                }
                if (updatedUser.permissions) {
                    dispatch(setPermissions(updatedUser.permissions));
                }
                dispatch(getUser(user.id));
            } else {
                dispatch(getUsers(getState().user.usersQuery));
            }

            dispatch(setAuthError(null));
            if (user.password) {
                dispatch(setUpdateSuccess(true));
            }
        } catch (error) {
            if (error.response && (error.response.status === 401 || error.response.data.error === 'Token Error')) {
                dispatch(logOut());
            } else {
                console.error(error);
                dispatch(setAuthError(error));
                dispatch(setUpdateSuccess(false));
            }
        } finally {
            dispatch(setNotLoading());
        }
    };
};



export const isAuthenticated = () => {
    return (dispatch, getState) => {
        const currentUser = getState().user.currentUser;
        const user = (currentUser == null || typeof currentUser !== 'object' || Object.keys(currentUser).length === 0)
            ? JSON.parse(localStorage.getItem('user'))
            : currentUser;

        if (user !== null && typeof user === 'object' && Object.keys(user).length !== 0 && localStorage.token) {
            return true;
        }
        return false;
    }
};


export const isAdmin = () => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user)
        return user.profile_id;

    return false;
}

export const showSessionExpiredModal = () => {
    return {
        type: userActionTypes.SHOW_SESSION_EXPIRED_MODAL
    };
};

export const hideSessionExpiredModal = () => {
    return {
        type: userActionTypes.HIDE_SESSION_EXPIRED_MODAL
    };
};

export const logOut = () => {
    return async (dispatch, getState) => {
        const currentUser = getState().user.currentUser;

        try {
            await http.post('/auth/logout');
        } catch (error) {
        }

        if (currentUser && currentUser.id) {
            try {
                await http.put(`/users/${currentUser.id}/presence`, { status: 3 });
                dispatch(setUserStatus({ userId: currentUser?.id, status: 3 }));
            } catch (error) {
                console.error('Erro ao atualizar o status do usuário', error);
            }
        }

        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('permissions');
        localStorage.removeItem('welcomeMsg');
        localStorage.removeItem('closingMsg');

        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && (key.startsWith('quickAccess') || key.startsWith('filter') || key.startsWith('room'))) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(key => localStorage.removeItem(key));

        resetAppBootstrapGate();
        dispatch({ type: userActionTypes.LOG_OUT });
        dispatch(hideSessionExpiredModal());
        resetSessionExpiredFlag();
        dispatch(push('/login'));
    };
};

export const login = (email, password, rememberMe = false) => {
    return async (dispatch, getState) => {
        dispatch(setLoading())
        try {
            const response = await http.post(`/auth`, { email, password, rememberMe });

            // Segunda camada. O bloqueio de verdade agora é da API, que
            // responde 403 e não emite token nenhum -- antes esta linha era o
            // ÚNICO obstáculo, e a API devolvia um token válido no corpo da
            // resposta, então qualquer chamada fora desta tela entrava com a
            // conta desativada. Mantida para o caso de o front subir antes
            // da API.
            if (response.data.user.status === 4)
                return dispatch(setAuthError('Operador inativo, entre em contato com o administrador do sistema.'));

            dispatch(setCurrentUser(response.data));
            dispatch(getTextConfig(response.data.user.service_group_id));
            dispatch(getTimeConfig(response.data.user.service_group_id));
            dispatch(getServiceGroups());
            dispatch(getUsers());
            dispatch(getProfiles());
            dispatch(getUserIndicators());
            dispatch(setToken(response.data.token));
            localStorage.setItem("token", "Bearer " + response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            dispatch(setPermissions(response.data.permissions));

            // Destino pós-login:
            // - Usuário "somente Orby" (ou que logou pela tela do /orby) vai SEMPRE pro
            //   Orby, para nunca cair na plataforma AloDesk.
            // - Caso contrário, respeita a rota de origem (deep-link via PrivateRoute).
            const st = getState();
            const fromPath = st.router?.location?.state?.from?.pathname;
            const currentPath = st.router?.location?.pathname;
            const isOrbyOnly = !!(response.data.user && response.data.user.orby_only);
            const dest = (isOrbyOnly || currentPath === '/orby') ? '/orby' : (fromPath || '/');
            dispatch(push(dest));
        } catch (error) {
            if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                dispatch(logOut());
            } else {
                // Extrai a mensagem de forma defensiva: dependendo do tipo de falha
                // (credencial, 4xx, 5xx, timeout/rede) o formato do erro muda, e
                // ler .error direto quebrava a tela quando o servidor estava fora.
                const em = error && error.errorMessage;
                const msg =
                    (em && typeof em === 'object' ? (em.error || em.message) : (typeof em === 'string' ? em : null))
                    || error?.response?.data?.error
                    || error?.response?.data?.message
                    // 403 (conta desativada): o interceptor não repassa
                    // `response` -- ele entrega o corpo em `responseData`. Sem
                    // estas duas linhas a pessoa via "Forbidden" na tela.
                    || error?.responseData?.message
                    || error?.responseData?.error
                    || 'Não foi possível fazer login. Verifique a conexão com o servidor e tente novamente.';
                dispatch(setAuthError(msg));
            }
        } finally {
            dispatch(setNotLoading());
        };
    };
};

export const createUser = (user) => {
    // `getState` entrou aqui para o recarregamento abaixo repetir o recorte
    // que a tela pediu, em vez de impor `includeInactive`.
    return (dispatch, getState) => {
        // Retorna a promise para que o chamador (formulário de operador) possa
        // realmente await: antes o thunk não retornava nada, então o await
        // resolvia de imediato e a tela mostrava "sucesso" e navegava mesmo
        // quando o backend rejeitava (e-mail duplicado, senha curta), deixando
        // o operador sem cadastro válido (não conseguia logar/usar o chat).
        return http
            .post(`/users`, { ...user })
            .then(response => {
                dispatch(getUsers(getState().user.usersQuery))
                dispatch(setAuthError(null));
                return response;
            })
            .catch(error => {
                if (error.errorMessage === 'Token Error' || error.errorStatus === 401) {
                    dispatch(logOut());
                } else {
                    console.log(error);
                    dispatch(setAuthError(error));
                }
                throw error;
            });
    };
}

export const sendResetPasswordEmail = (email) => {
    return dispatch => {
        http
            .post(`/password/create`, { email: email })
            .then(response => {
                dispatch(setAuthError(null));
                dispatch(setUpdateSuccess('emailSent'));
            })
            .catch(error => {
                console.log(error)
                dispatch(setUpdateSuccess(null));
                dispatch(setAuthError(error));
            });
    };
}

export const resetPassword = (password, password_confirmation, token, email) => {
    return dispatch => {
        http
            .post(`/password/reset`, { password: password, password_confirmation: password_confirmation, token: token, email: email })
            .then(response => {
                dispatch(setAuthError(null));
                dispatch(setUpdateSuccess('passwordChanged'));
            })
            .catch(error => {
                dispatch(setUpdateSuccess(null));
                
                // Trata erros específicos do backend
                if (error.response && error.response.data && error.response.data.errors) {
                    const errors = error.response.data.errors;
                    let errorMessage = 'Erro ao redefinir senha: ';
                    
                    if (errors.password) {
                        errorMessage += errors.password.join(', ');
                    } else if (errors.email) {
                        errorMessage += errors.email.join(', ');
                    } else if (errors.token) {
                        errorMessage += errors.token.join(', ');
                    } else {
                        errorMessage += 'Dados inválidos';
                    }
                    
                    dispatch(setAuthError({ errorMessage: errorMessage }));
                } else {
                    dispatch(setAuthError(error));
                }
            });
    };
}